import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const ChangeStateContext = createContext(null);

type Props = {
  children: ReactElement;
};

const ChangeStateProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload: any) => {
      const data = await Api.post(
        `tm/transactions/${payload.id}/status`,
        payload,
      );
      return data;
    },
    onError: (err) => {
      console.log(err, "###");
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <ChangeStateContext.Provider value={contextValue}>
      {children}
    </ChangeStateContext.Provider>
  );
};

export default ChangeStateProvider;
